/* eslint-disable
    func-names,
    no-param-reassign,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const filter = $locale =>
  function (i) {
    // `toLocaleString` doesn't work in all browsers (eg. Safari)
    // TODO: Find an alternative solution when we need globalization
    // or enable when supported by Safari

    // date = new Date()
    // date.setDate 1
    // date.setMonth i
    // date.toLocaleString $locale.id, month: "long"

    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    if (i < 0 || i > 11) {
      i = 0;
    }

    return months[i];
  };
module.exports = filter;
